import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { AccountSetupDialogStore } from '../../account-setup-dialog.store';
import { Subject } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import {
  AccountConfigType,
  AccountConfigTypeLabels
} from '../../../../models/account-config-type';
import { MatOption } from '@angular/material/core';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'account-mapping-field',
    templateUrl: './account-mapping-field.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AccountMappingFieldComponent),
            multi: true
        }
    ],
    standalone: true,
    imports: [MatFormField, MatLabel, MatSelect, ReactiveFormsModule, NgFor, MatOption, AsyncPipe]
})
export class AccountMappingFieldComponent implements ControlValueAccessor {
  onChange = (rating: number) => {};
  onTouched = () => {};
  formControl = new FormControl(null, Validators.required);
  private typeSubject = new Subject<'revenue' | 'payment' | 'expense'>();
  label = '';

  @Input() set key(key: string) {
    this.label = this.getLabelForKey(key);
  }

  @Input() set type(type: 'revenue' | 'payment' | 'expense') {
    this.typeSubject.next(type);
  }

  options = this.store.accounts$;

  constructor(
    private store: AccountSetupDialogStore,
    private configService: ConfigService
  ) {
    this.formControl.valueChanges.subscribe((value) => this.onChange(value));
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.formControl.setValue(obj);
    this.onChange(obj);
  }

  private getLabelForKey(key: string) {
    if (key.startsWith(AccountConfigType.CHEQUE_PAYMENTS_PREFIX)) {
      const currency = key.substring(key.length - 3);
      return (
        AccountConfigTypeLabels[AccountConfigType.CHEQUE_PAYMENTS_PREFIX] +
        ` (${currency})`
      );
    }
    if (key.startsWith(AccountConfigType.CASH_PAYMENTS_PREFIX)) {
      const currency = key.substring(key.length - 3);
      return (
        AccountConfigTypeLabels[AccountConfigType.CASH_PAYMENTS_PREFIX] +
        ` (${currency})`
      );
    }
    return AccountConfigTypeLabels[key];
  }
}
